import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {SiteContextService} from "../../services/site-context.service";

export class PackagesMultiSelectComponent implements IController {

  selectedIds: any;
  options: any;
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  onChange: Function;

  public selectedPackages: any;
  public selectedText: any;

  constructor(private $mdPanel, private $element, private siteContextService: SiteContextService, private $filter) {
  }

  $onInit() {
    if (!this.options) {
      this.options = this.siteContextService.getSiteInfo().itemSettings;
    }
    this._setSelectedPackages();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedPackages();
    }
  };

  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const optionsRef = this.options;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'packagesIds';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }
        if (!selectedIds?.length) {
          this.onChange({packages: [], selectedIds: []});
        } else {
          const packages = _.filter(this.options, (o) => {
            return _.includes(selectedIds, o.id);
          });
          this.onChange({packages: packages, selectedIds: selectedIds});
        }
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({packages: [], selectedIds: []});
  }

  private _setSelectedPackages() {
    if (!!this.selectedIds?.length) {
      if (!!this.options) {
        this.selectedPackages = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
        this._setSelectedText();
      }
    } else {
      this.selectedPackages = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {


    if (this.selectedPackages.length === 0) {
      this.selectedText = '';
    }
    if (this.selectedPackages.length === 1) {
      this.selectedText = this.selectedPackages[0].name;
    } else if (this.selectedPackages.length > 1) {
      let string = '';
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext("2d");

      _.forEach(this.selectedPackages, (b, i) => {
        string += b.name;
        if ((i + 1) < this.selectedPackages.length) {
          string += ', '
        }
      });

      let stringWidth = ctx.measureText(string).width;

      if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
        string = this.$filter('translate')('X_PACKAGES', {sum: this.selectedPackages.length})
      }

      this.selectedText = string;
    }
  }


}

angular
  .module('bringoz.admin.commons')
  .component('packagesMultiSelect', {
    bindings: {
      selectedIds: '<?',
      options: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./packages-multi-select.html').default,
    controller: PackagesMultiSelectComponent
  });
